var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarLandingSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 607.168,
    height: 427.53,
    viewBox: "0 0 607.168 427.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #3f3d56;\n      }\n\n      .cls-2 {\n        fill: #ccc;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: green;\n      }\n\n      .cls-5 {\n        fill: #e6e6e6;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_order_ride_re_372k",
    transform: "translate(-0.001 -4.521)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    className: "cls-1",
    d: "M325.1,540.375a10.221,10.221,0,0,0-10.21,10.21V574.47a10.221,10.221,0,0,0,10.21,10.21h12.95a10.221,10.221,0,0,0,10.21-10.21V550.585a10.221,10.221,0,0,0-10.21-10.21Z",
    transform: "translate(-140.709 -233.975)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    className: "cls-1",
    d: "M564.482,585.475h-12.95a11.017,11.017,0,0,1-11-11V550.585a11.016,11.016,0,0,1,11-11h12.95a11.017,11.017,0,0,1,11,11V574.47a11.017,11.017,0,0,1-11,11Z",
    transform: "translate(-140.709 -233.975)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    className: "cls-2",
    d: "M555.889,566.35H332.9c-10.148,0-18.4-5.983-18.4-13.336v-42.88l11.068-11.656H565.379l8.915,11.681v42.855C574.294,560.367,566.038,566.35,555.889,566.35Z",
    transform: "translate(-140.709 -233.975)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    className: "cls-2",
    d: "M564.338,519.929h-237.5L324.42,482.92l1.536-3.787,8.928-21.969h219.8l12.071,24.947Z",
    transform: "translate(-140.709 -233.975)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    className: "cls-3",
    d: "M425.64,248.216l-1.772,27.807H371.614V255.366l52.54-10.217Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    className: "cls-3",
    d: "M237.345,255.366v20.657H185.877l-1.764-27.013,1.5-3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    className: "cls-2",
    d: "M553.356,463.52H336.206l23.161-77.2a15.5,15.5,0,0,1,14.763-11.093l143.811-1.37a15.564,15.564,0,0,1,15.219,11.664Z",
    transform: "translate(-140.709 -233.975)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    className: "cls-3",
    d: "M536.639,456.22l-183.752-2.179a1.485,1.485,0,0,1-1.4-1.938l17.616-54.96a1.485,1.485,0,0,1,1.414-1.032h147.8a1.485,1.485,0,0,1,1.414,1.031l18.341,57.139a1.485,1.485,0,0,1-1.431,1.938Z",
    transform: "translate(-140.709 -233.975)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    className: "cls-4",
    d: "M469.545,383.276H420.017c-.417,0-.8-.411-.988-1.073a3.34,3.34,0,0,1,.079-2.059l4.084-10.328c.208-.526.548-.841.909-.841h41.36c.361,0,.7.314.909.841l4.084,10.328a3.339,3.339,0,0,1,.079,2.059C470.341,382.865,469.962,383.276,469.545,383.276Z",
    transform: "translate(-140.709 -233.975)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    className: "cls-2",
    d: "M336.342,461.931H303.768v-7.16a8.74,8.74,0,0,1,8.73-8.73h23.844Z",
    transform: "translate(-140.709 -233.975)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    className: "cls-2",
    d: "M585.814,461.931H553.24v-15.89h23.844a8.74,8.74,0,0,1,8.73,8.73Z",
    transform: "translate(-140.709 -233.975)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114",
    "data-name": "Rectangle 114",
    className: "cls-1",
    width: 169.21,
    height: 2,
    transform: "translate(0.001 396.774) rotate(-19.76)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_115",
    "data-name": "Rectangle 115",
    className: "cls-1",
    width: 2,
    height: 169.21,
    transform: "translate(447.241 341.454) rotate(-70.245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    className: "cls-5",
    d: "M453.64,615.025h-9.532V602.714h9.532Zm0-24.624h-9.532V578.089h9.532Z",
    transform: "translate(-140.709 -233.975)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    className: "cls-5",
    d: "M453.64,666.025h-9.532V653.714h9.532Zm0-24.624h-9.532V629.089h9.532Z",
    transform: "translate(-140.709 -233.975)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_99",
    "data-name": "Ellipse 99",
    className: "cls-4",
    cx: 47.29,
    cy: 47.29,
    r: 47.29,
    transform: "translate(256.505 4.521)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    className: "cls-3",
    d: "M299.288,71.773l-14.154-18.2,8.231-6.4,6.7,8.617,22.64-23.9,7.571,7.173Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarLandingSmall);
export default __webpack_public_path__ + "static/media/car_landing_small.c8521c58d88e79505d10feab0ae329f7.svg";
export { ForwardRef as ReactComponent };